import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { TEST_IDS } from '../../TestIds';
import { locale } from '../locale';
import { RedirectLink } from './RedirectLink';
export const StatusLink = props => {
  return /*#__PURE__*/React.createElement(RedirectLink, _extends({
    href: "https://developer.status.atlassian.com",
    "data-testid": TEST_IDS.APP_STATUS_LINK,
    target: "_blank"
  }, props), props.children || locale.statusPage);
};